<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiUndo } from "@mdi/js";
export default {
  name: "MdiUndo",
  data() {
    return {
      svgPath: mdiUndo,
    };
  },
};
</script>
